import Vue from 'vue';
import Auth from './Auth.js';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'admin',
    component: require('./components/Admin/Index.vue').default,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'settings',
        name: 'settings.home',
        component: require('./components/Admin/Settings/Index.vue').default,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'project',
            name: 'settings.project',
            component: require('./components/Admin/Settings/Project.vue').default,
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'journals',
        name: 'journals.home',
        component: require('./components/Admin/Journals/Index.vue').default,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '77',
            name: 'journals.77',
            component: require('./components/Admin/Journals/77.vue').default,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: '21',
            name: 'journals.21',
            component: require('./components/Admin/Journals/21.vue').default,
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'protocols',
        name: 'protocols.home',
        component: require('./components/Admin/Protocols/Index.vue').default,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'work',
            name: 'protocols.work',
            component: require('./components/Admin/Protocols/Work.vue').default,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'template',
            name: 'protocols.template',
            component: require('./components/Admin/Protocols/Template.vue').default,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'settings',
            name: 'protocols.settings',
            component: require('./components/Admin/Protocols/Settings.vue').default,
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'project/:id',
        name: 'project.index',
        component: require('./components/Admin/Project/Index.vue').default,
        props: true,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: 'organization',
            name: 'project.organization',
            component: require('./components/Admin/Project/Organization.vue').default,
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'pack',
            name: 'project.pack',
            component: require('./components/Admin/Project/Pack.vue').default,
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'template',
            name: 'project.template',
            component: require('./components/Admin/Project/Template.vue').default,
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'field',
            name: 'project.field',
            component: require('./components/Admin/Project/Field.vue').default,
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'category',
            name: 'project.category',
            component: require('./components/Admin/Project/Category.vue').default,
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'folder',
            name: 'project.folder',
            component: require('./components/Admin/Project/Folder.vue').default,
            props: true,
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      { path: '*', component: require('./components/NotFound.vue').default }
    ]
  },



];

const router = new VueRouter({
     mode: 'history',
     routes: routes
 });


export default router;
